import { render, staticRenderFns } from "./studioDashboardDaycareInsights.vue?vue&type=template&id=24989cb8&scoped=true"
import script from "./studioDashboardDaycareInsights.vue?vue&type=script&lang=js"
export * from "./studioDashboardDaycareInsights.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardDaycareInsights.vue?vue&type=style&index=0&id=24989cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24989cb8",
  null
  
)

export default component.exports